import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {OrdersRoutingModule} from './orders-routing.module';
import {OrdersListComponent} from './orders-list/orders-list.component';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {SharedModule} from "@shared/shared.module";
import {OrdersService} from "@app/features/orders/orders.service";
import {FormsModule} from "@angular/forms";
import {NgxSpinnerModule} from "ngx-spinner";
import {PopoverModule} from "ngx-bootstrap/popover";
import {OrdersDetailsComponent} from "@app/features/orders/orders-details/orders-details.component";
import {QRCodeModule} from "angularx-qrcode";


@NgModule({
  declarations: [
    OrdersListComponent,
    OrdersDetailsComponent
  ],
  imports: [
    CommonModule,
    OrdersRoutingModule,
    BsDatepickerModule,
    SharedModule,
    FormsModule,
    NgxSpinnerModule,
    PopoverModule,
    QRCodeModule
  ],
  providers: [OrdersService]
})
export class OrdersModule {
}
